<div class="list-items">
    <div *ngFor="let item of data_items" class="list-item" routerLinkActive="list-item-active" routerLink="{{ routeUrl + item.id }}" >
        <ng-template [ngTemplateOutlet]="templateRef" [ngTemplateOutletContext]="{$implicit: item}"></ng-template>
    </div>
</div>
